import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, GridProps, InputAdornment, SelectChangeEvent } from "@mui/material";
import { Search } from "@mui/icons-material";
import { InputSearching, InputDate, AppSelect } from "@/components/common";
import { AppConstant, LangConstant } from "@/const";
import { InternalRequestFilter, useApplicationList, useRequestStatusList } from "@/hooks";

type InternalFilterProps = GridProps & {
  filter?: InternalRequestFilter;
  onChangeFilter?: (filter: InternalRequestFilter) => void;
};

const InternalFilter: FC<InternalFilterProps> = props => {
  const { filter, onChangeFilter } = props;
  const [filterTable, setFilterTable] = useState<InternalRequestFilter>({
    ...filter,
  });
  const { applicationList } = useApplicationList();
  const { t: getLabel } = useTranslation(LangConstant.NS_REQUEST);

  const reqStatusList = useRequestStatusList();

  const handleChangeFilter = (newFilter: InternalRequestFilter) => {
    setFilterTable(newFilter);
    if (onChangeFilter) {
      onChangeFilter(newFilter);
    }
  };

  const handleChangeApplication = (event: SelectChangeEvent<unknown>) => {
    handleChangeFilter({
      ...filterTable,
      applicationSendUid: String(event.target.value),
    });
  };

  const handleChangeRequestStatus = (event: SelectChangeEvent<unknown>) => {
    handleChangeFilter({
      ...filterTable,
      status: String(event?.target?.value) || undefined,
    });
  };
  const handleChangeSearchId = (keyword: string) => {
    handleChangeFilter({ ...filterTable, id: keyword });
  };
  const handleChangeStartDate = (value: Date | null) => {
    handleChangeFilter({ ...filterTable, startDate: value });
  };
  const handleChangeEndDate = (value: Date | null) => {
    handleChangeFilter({ ...filterTable, endDate: value });
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <InputSearching
          placeholder={getLabel("OBJ_INTERNAL_INPUT_SEARCH.search")}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
          defaultValue={filterTable?.id}
          onSearch={handleChangeSearchId}
        />
      </Grid>

      <Grid item xs={3}>
        <AppSelect
          label={getLabel("OBJ_INTERNAL_INPUT_SEARCH.reqSystem")}
          data={applicationList}
          value={filter?.applicationSendUid}
          onChange={handleChangeApplication}
        />
      </Grid>

      <Grid item xs={3}>
        <AppSelect
          label={getLabel("OBJ_INTERNAL_INPUT_SEARCH.reqStatus")}
          data={reqStatusList}
          value={filter?.status}
          onChange={handleChangeRequestStatus}
        />
      </Grid>

      <Grid item xs={3}>
        <InputDate
          label={getLabel("OBJ_INTERNAL_INPUT_SEARCH.fromDate")}
          format={AppConstant.FM_SHORT_DATE}
          onChange={handleChangeStartDate}
          maxDate={filterTable.endDate || undefined}
        />
      </Grid>

      <Grid item xs={3}>
        <InputDate
          label={getLabel("OBJ_INTERNAL_INPUT_SEARCH.toDate")}
          format={AppConstant.FM_SHORT_DATE}
          onChange={handleChangeEndDate}
          minDate={filterTable.startDate || undefined}
        />
      </Grid>
    </Grid>
  );
};

export default InternalFilter;
